import { IsNotEmpty, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class PlantIdRequest {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;
}